var _path, _g, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 203,
    viewBox: "0 0 229 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2848_3762",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 37,
    width: 129,
    height: 129
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.162 165.324C149.597 165.324 178.324 136.597 178.324 101.162C178.324 65.7262 149.597 37 114.162 37C78.7262 37 50 65.7262 50 101.162C50 136.597 78.7262 165.324 114.162 165.324Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2848_3762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.162 165.324C149.597 165.324 178.324 136.597 178.324 101.162C178.324 65.7262 149.597 37 114.162 37C78.7262 37 50 65.7262 50 101.162C50 136.597 78.7262 165.324 114.162 165.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.932 179.252C142.89 179.252 166.366 155.365 166.366 125.899C166.366 96.4332 142.89 72.5461 113.932 72.5461C84.9742 72.5461 61.499 96.4332 61.499 125.899C61.499 155.365 84.9742 179.252 113.932 179.252Z",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2848_3762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.941 98.3027H27.4629V183.852H199.941V98.3027Z",
    fill: "#23262F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.941 98.3027H27.4629V183.852H199.941V98.3027Z",
    fill: "url(#paint0_linear_2848_3762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.118829,
    d: "M114.263 107.663C120.463 107.663 125.489 105.333 125.489 102.46C125.489 99.5869 120.463 97.2577 114.263 97.2577C108.062 97.2577 103.036 99.5869 103.036 102.46C103.036 105.333 108.062 107.663 114.263 107.663Z",
    fill: "#23262F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.932 105.662C127.914 105.662 136.009 92.6761 136.009 79.4671C136.009 66.2582 126.125 57.828 113.932 57.828C101.739 57.828 91.8545 66.2582 91.8545 79.4671C91.8545 92.6761 99.9489 105.662 113.932 105.662Z",
    fill: "#777E90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.668 102.657C124.938 96.2888 128.342 88.4323 122.345 76.663C116.348 64.8938 117.223 56.5422 106.359 62.0776C95.4954 67.6131 90.5157 79.6118 96.5124 91.3811C102.509 103.15 112.724 109.743 130.668 102.657Z",
    fill: "#777E90"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.583333
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.583333,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.238 118.298L141.02 115.586C142.034 115.515 142.964 116.151 143.265 117.122L152.923 148.258C153.281 149.414 152.635 150.641 151.48 151C151.318 151.05 151.152 151.081 150.983 151.093L97.3129 154.846C96.106 154.93 95.0593 154.02 94.9749 152.813C94.9631 152.645 94.9708 152.476 94.9979 152.309L100.228 120.131C100.391 119.128 101.223 118.369 102.238 118.298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.421082,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4669 116.06L127.131 120.124C128.143 120.23 128.948 121.018 129.076 122.026L133.18 154.367C133.332 155.567 132.482 156.663 131.282 156.816C131.115 156.837 130.945 156.839 130.778 156.821L77.2706 151.197C76.0675 151.071 75.1946 149.993 75.3211 148.79C75.3387 148.622 75.3757 148.457 75.4313 148.297L86.1697 117.517C86.5046 116.557 87.4559 115.954 88.4669 116.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M138.739 139.732C138.842 139.629 138.978 139.577 139.113 139.577C139.249 139.577 139.384 139.629 139.488 139.732L142.137 142.381C142.343 142.588 142.343 142.923 142.137 143.13C141.93 143.337 141.594 143.337 141.387 143.13L139.113 140.856L137.898 142.071C137.692 142.278 137.356 142.278 137.149 142.071C136.942 141.864 136.942 141.528 137.149 141.322L138.739 139.732Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.496 131.747C137.6 131.644 137.735 131.592 137.871 131.592C138.007 131.592 138.142 131.644 138.245 131.747L140.894 134.396C141.101 134.603 141.101 134.938 140.894 135.145C140.687 135.352 140.352 135.352 140.145 135.145L137.871 132.871L136.656 134.086C136.449 134.293 136.114 134.293 135.907 134.086C135.7 133.879 135.7 133.544 135.907 133.337L137.496 131.747Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.803 123.369C135.907 123.265 136.042 123.214 136.178 123.214C136.313 123.214 136.449 123.265 136.552 123.369L139.201 126.018C139.408 126.225 139.408 126.56 139.201 126.767C138.994 126.974 138.659 126.974 138.452 126.767L136.178 124.493L134.963 125.707C134.756 125.914 134.421 125.914 134.214 125.707C134.007 125.501 134.007 125.165 134.214 124.958L135.803 123.369Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.425 142.785L130.129 140.988C130.421 140.967 130.674 141.187 130.695 141.479C130.715 141.771 130.495 142.024 130.203 142.045L104.499 143.842C104.207 143.863 103.954 143.642 103.933 143.351C103.913 143.059 104.133 142.806 104.425 142.785Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.494 133.789L129.216 132.13C129.508 132.11 129.761 132.33 129.781 132.622C129.802 132.913 129.582 133.167 129.29 133.187L105.568 134.846C105.276 134.866 105.023 134.646 105.003 134.354C104.982 134.062 105.202 133.809 105.494 133.789Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.201 125.668L129.04 124.07C129.332 124.05 129.585 124.27 129.606 124.562C129.626 124.854 129.406 125.107 129.114 125.127L106.275 126.724C105.983 126.745 105.73 126.525 105.71 126.233C105.689 125.941 105.909 125.688 106.201 125.668Z",
    fill: "#1B3554"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2848_3762)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7551 108.618H135.057C136.127 108.618 137.041 109.391 137.218 110.447L142.961 144.713C143.161 145.906 142.356 147.036 141.163 147.236C141.044 147.256 140.922 147.266 140.801 147.266H86.0401C84.8303 147.266 83.8496 146.285 83.8496 145.075C83.8496 144.934 83.8633 144.793 83.8905 144.654L90.6055 110.388C90.8069 109.36 91.7077 108.618 92.7551 108.618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M132.431 134.588C132.311 134.483 132.161 134.438 132.014 134.448C131.867 134.458 131.725 134.524 131.62 134.644L128.953 137.712C128.745 137.952 128.77 138.315 129.01 138.523C129.249 138.732 129.613 138.706 129.821 138.467L132.111 135.833L133.518 137.056C133.758 137.264 134.121 137.238 134.329 136.999C134.537 136.759 134.512 136.396 134.272 136.188L132.431 134.588Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.691 125.849C131.571 125.744 131.421 125.699 131.274 125.709C131.127 125.719 130.984 125.785 130.88 125.905L128.213 128.974C128.005 129.213 128.03 129.576 128.27 129.785C128.509 129.993 128.872 129.967 129.081 129.728L131.371 127.094L132.778 128.317C133.017 128.525 133.38 128.5 133.589 128.26C133.797 128.02 133.772 127.657 133.532 127.449L131.691 125.849Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M130.491 116.65C130.371 116.546 130.22 116.5 130.074 116.51C129.927 116.52 129.784 116.587 129.68 116.707L127.013 119.775C126.804 120.014 126.83 120.378 127.069 120.586C127.309 120.794 127.672 120.769 127.88 120.529L130.17 117.895L131.578 119.118C131.817 119.326 132.18 119.301 132.389 119.061C132.597 118.822 132.571 118.459 132.332 118.25L130.491 116.65Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8972 137.485H121.862C122.179 137.485 122.437 137.743 122.437 138.06C122.437 138.378 122.179 138.635 121.862 138.635H93.8972C93.5797 138.635 93.3223 138.378 93.3223 138.06C93.3223 137.743 93.5797 137.485 93.8972 137.485Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.737 127.827H121.544C121.862 127.827 122.119 128.084 122.119 128.402C122.119 128.719 121.862 128.977 121.544 128.977H95.737C95.4195 128.977 95.1621 128.719 95.1621 128.402C95.1621 128.084 95.4195 127.827 95.737 127.827Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1169 119.088H121.964C122.281 119.088 122.539 119.345 122.539 119.663C122.539 119.98 122.281 120.238 121.964 120.238H97.1169C96.7994 120.238 96.542 119.98 96.542 119.663C96.542 119.345 96.7994 119.088 97.1169 119.088Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.693 134.747H121.892C122.21 134.747 122.467 135.005 122.467 135.322C122.467 135.64 122.21 135.897 121.892 135.897H102.693C102.376 135.897 102.118 135.64 102.118 135.322C102.118 135.005 102.376 134.747 102.693 134.747Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.979 125.089H121.671C121.988 125.089 122.246 125.346 122.246 125.664C122.246 125.981 121.988 126.238 121.671 126.238H103.979C103.662 126.238 103.404 125.981 103.404 125.664C103.404 125.346 103.662 125.089 103.979 125.089Z",
    fill: "#1B3554"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.944 116.35H121.964C122.282 116.35 122.539 116.607 122.539 116.925C122.539 117.242 122.282 117.5 121.964 117.5H104.944C104.627 117.5 104.369 117.242 104.369 116.925C104.369 116.607 104.627 116.35 104.944 116.35Z",
    fill: "#1B3554"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.382 62.4772L141.785 65.9177L142.708 64.7365L140.159 62.745L140.212 62.6777L145.3 61.2801L146.029 60.3476L141.729 56.9881L140.806 58.1693L143.344 60.1526L143.292 60.2199L138.033 61.6431L137.382 62.4772Z",
    fill: "#777E90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.059 64.2992L160.14 67.7853L161.076 65.3493L155.819 63.3314L155.872 63.1925L163.631 58.2764L164.37 56.3532L155.502 52.9491L154.566 55.3851L159.802 57.3948L159.748 57.5337L151.719 62.579L151.059 64.2992Z",
    fill: "#777E90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.194 65.089L193.854 55.3031L191.229 51.1024L182.165 56.7667L182.015 56.5272L183.426 39.1474L181.354 35.831L166.062 45.3866L168.686 49.5873L177.714 43.9461L177.864 44.1856L176.34 62.1227L178.194 65.089Z",
    fill: "#777E90"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2848_3762",
    x: 23.4629,
    y: 89.3027,
    width: 180.478,
    height: 94.5491,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0924196 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2848_3762"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2848_3762",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2848_3762",
    x: 82.8496,
    y: 108.618,
    width: 67.1426,
    height: 46.6473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.901432 0 0 0 0 0.932264 0 0 0 0 0.951318 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2848_3762"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2848_3762",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2848_3762",
    x1: 195.815,
    y1: 121.438,
    x2: 176.602,
    y2: 160.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFEAF0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowEmpty);
export default __webpack_public_path__ + "static/media/follow-empty.d48dae37.svg";
export { ForwardRef as ReactComponent };